import type { NumeralThousandsGroupStyleType } from "cleave.js/options";

import type { MaskConfig } from "./types";

const AGE_DECIMAL_DECIMALS = 1;

/**
 * simple numeric mask - integers only, no decimals
 * used for: counts, whole numbers
 */
export const numberMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
  },
  placeholder: "",
  formatValue: (rawValue) => rawValue || "",
});

/**
 * age mask - 3 digit maximum, no decimals
 * used for: age fields
 */
export const ageMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
    blocks: [3],
  },
  placeholder: "XXX",
  formatValue: (rawValue) => rawValue || "",
});

/**
 * age with one decimal place (e.g., 25.5)
 * used for: precise age calculations
 * @param maxLength - total digits (e.g., 14 for numeric(14,1))
 */
export const ageDecimalMask = (maxLength?: number): MaskConfig => {
  const integerScale = maxLength ? maxLength - AGE_DECIMAL_DECIMALS : 3;

  return {
    cleaveOptions: {
      numeral: true,
      numeralDecimalScale: AGE_DECIMAL_DECIMALS,
      numeralDecimalMark: ".",
      numeralThousandsGroupStyle: "none" as NumeralThousandsGroupStyleType,
      numeralPositiveOnly: true,
      numeralIntegerScale: integerScale,
    },
    placeholder: "XXX.X",
    formatValue: (rawValue) => rawValue || "",
    decimalPlaces: AGE_DECIMAL_DECIMALS,
  };
};
